import 'polyfill-array-includes'

import ReactGA from 'react-ga'
import { loadScript } from 'helpers/loadScriptAsync'
import { googleAnalyticsTrackingID } from 'app/config'
import { ravenInit, i18Init } from './libraries'

export default function () {
  /** Google Analytics */
  try {
    ReactGA.initialize(googleAnalyticsTrackingID)
  } catch (error) {
    console.log('[GA]: loading failed - ', error)
  }

  // Register service worker.
  // if ('serviceWorker' in navigator) {
  //   window.addEventListener('load', () => {
  //     navigator.serviceWorker.register('/service-worker.js').then(reg => {
  //       console.log('Service worker registered.', reg)
  //     })
  //   })
  // }

  if (process.env.WEBPACK_FILE !== 'local') {
    ravenInit().catch(err => console.log(err))
  }

  // initialization translations
  i18Init()

  /** Fresh Desc @see https://freshdesk.com/ */
  // loadScript('//assets.freshdesk.com/widget/freshwidget.js')
  //   .catch(err => console.log('Failed load script', err))
  //   .then(() =>
  //     window.FreshWidget.init('', {
  //       queryString: '&widgetType=popup&formTitle=Submit+Feedback&submitTitle=Submit',
  //       backgroundImage: 'https://assets.prohabits.com/freshdesk-icon-export.svg',
  //       utf8: '✓',
  //       widgetType: 'popup',
  //       buttonType: 'image',
  //       buttonText: 'Support',
  //       buttonColor: 'white',
  //       buttonBg: '#006063',
  //       alignment: '3',
  //       offset: '10px',
  //       formHeight: '500px',
  //       url: 'https://prohabits.freshdesk.com',
  //     })
  //   )

  if (process.env.SERVER === 'production') {
    /** Crazy Egg @see https://www.crazyegg.com/ */
    loadScript('//script.crazyegg.com/pages/scripts/0082/6370.js').catch(err => console.log('Failed load script', err))
  }

  // pollyfill for IE by CustomEvent
  ;(function () {
    if (typeof window.CustomEvent === 'function') return false

    function CustomEvent(event, params) {
      params = params || { bubbles: false, cancelable: false, detail: undefined }
      const evt = document.createEvent('CustomEvent')
      evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail)
      return evt
    }

    CustomEvent.prototype = window.Event.prototype

    window.CustomEvent = CustomEvent
  })()

  // error: "Can't find variable: __gCrWeb"
  // @see https://stackoverflow.com/questions/26483541/referenceerror-cant-find-variable-gcrweb
  if (!window.__gCrWeb) window.__gCrWeb = {}
}
